// =============================================================================
// (2026-08-14, defecto B) ESTATUS DE LA GUÍA DE DESPACHO — FUENTE ÚNICA del
// frontend para decidir si una guía está anulada.
//
// POR QUÉ EXISTE ESTE ARCHIVO: la comparación vivía DUPLICADA y las dos copias
// no coincidían. La vista pública del QR (`PublicDispatchGuideView`) normalizaba
// —trim + minúsculas— y el PDF (`DispacheGuidesPDF/dispacheGuidesPDF.js`)
// comparaba `=== "anulada"` sensible a mayúsculas. Resultado MEDIDO: una guía
// con estatus 'ANULADA' salía en el PDF **sin el sello ANULADO** mientras el QR
// sí avisaba de la anulación. El fiscal en la alcabala ve el papel.
//
// EL ORIGEN DE LAS MAYÚSCULAS (ya cerrado en el backend el mismo día):
// `guia_despacho.estatus` era VARCHAR(20) sin restricción y el alta lo escribía
// con texto libre del payload, así que la columna pudo quedarse con 'ANULADA',
// ' anulada ' o 'anulado'. A partir de la migración `c5e8a1d47b3f` la BD sólo
// admite ('pendiente', 'anulada', 'anulado') y la capa web sólo escribe las dos
// primeras — pero LAS FILAS HISTÓRICAS anteriores a esa migración siguen
// existiendo, así que esta normalización NO es defensa redundante: es lo que
// hace que un documento viejo se pinte bien.
//
// LOS DOS VALORES: 'anulada' es el que escribe la cascada de anulación de la
// factura (`factura_routes.ESTATUS_GUIA_ANULADA` /
// `models.ESTATUS_GUIA_ANULADA`); 'anulado' es la grafía HEREDADA que la
// restricción de la BD tolera y que nada escribe ya.
// =============================================================================

export const ESTATUS_GUIA_ANULADA = ["anulada", "anulado"];

// Acepta cualquier cosa (null, undefined, número, objeto) y sólo dice `true`
// cuando el valor, normalizado, es uno de los dos anulados. Nunca lanza: se usa
// en el camino de render del PDF y de la vista pública, donde una excepción
// dejaría al usuario sin documento.
export const esGuiaAnulada = (estatus) => {
  if (estatus === null || estatus === undefined) return false;
  return ESTATUS_GUIA_ANULADA.includes(String(estatus).trim().toLowerCase());
};
